import {FlatList, Text, TouchableOpacity, View} from 'react-native';
import {createStyles} from '../../../../utils/createStyles';

interface ButtonsProps {
  BtnList: Array<any>;
  currentSenceType: string | number;
  setCurrentSenceType: React.Dispatch<React.SetStateAction<string | number>>;
}

const Buttons: React.FC<ButtonsProps> = ({
  BtnList,
  currentSenceType,
  setCurrentSenceType,
}) => {
  return (
    <FlatList
      data={BtnList}
      renderItem={({item}) => {
        return (
          <TouchableOpacity
            key={item.id + 'btns'}
            onPress={() => {
              setCurrentSenceType(item.id);
            }}
            activeOpacity={1}
            style={[
              styles.ButtonsItem,
              currentSenceType === item.id && styles.ButtonsItemActive,
            ]}>
            <Text
              style={[
                styles.ButtonsItemText,
                currentSenceType === item.id && styles.ButtonsItemTextActive,
              ]}>
              {item.name}
            </Text>
          </TouchableOpacity>
        );
      }}
    />
  );
};
const styles = createStyles({
  ButtonsItem: {
    width: '10.7rem',
    height: '4rem',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#D5D5FF',
    borderRadius: '0.75rem',
    marginBottom: '1.5rem',
  },
  ButtonsItemActive: {
    backgroundColor: '#6658FF',
  },
  ButtonsItemTextActive: {
    color: '#fff',
  },
  ButtonsItemText: {
    color: '#69659B',
    fontSize: '1.4rem',
  },
});
export default Buttons;
